module.exports = __webpack_public_path__ + "img/serviceGIS.a0988794.png";